import { PaymentsWidgetAPI } from '@wix/cashier-payments-widget';

const isValidationError = (e: any) => e?.isValid === false;

export async function fetchPaymentMethodWithFallback(
  paymentsWidgetApi: PaymentsWidgetAPI | undefined,
  panoramaClient: any,
  endInteraction: () => void,
): Promise<{ paymentAgreementId: string } | undefined> {
  return paymentsWidgetApi?.getSavedPaymentMethod().catch((e) => {
    if (!isValidationError(e)) {
      try {
        panoramaClient.errorMonitor().addBreadcrumb({
          message: 'error in payments side when trying to create/get payment method on payments cashier widget',
        });
        panoramaClient.errorMonitor().reportError(e);
      } catch (err) {
        // Silently catch any errors in error reporting to prevent breaking the app
      }
    }
    endInteraction();
    return undefined;
  });
}
